import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({ children, className, ...props }) => (
  <div className={classnames(className, 'modal-body')} data-testid="ModalBody" {...props}>
    {children}
  </div>
);

ModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalBody.defaultProps = {
  children: null,
  className: null,
};

export default ModalBody;
